// extracted by mini-css-extract-plugin
module.exports = {"backgroundImage":"TwoInfoBoxesWithIconsLightBkgd-module--background-image--1UuG1","infoBox":"TwoInfoBoxesWithIconsLightBkgd-module--info-box--2Sj1l"};